import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { WorkoutService, AlertService } from "../../../services";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import {
  WorkoutsState,
  Observable,
  Store,
  take,
  Types,
  AutoUnsubscribe,
  Subscription,
  StorageUtil,
  InputUtil,
  filter,
  map,
  of,
} from "../store";
import { Fields } from "../store";
import { DomSanitizer } from "@angular/platform-browser";
import * as lodash from "lodash";
import { InjuryService } from "../../../services/injury.service ";
import { ActivatedRoute } from "@angular/router";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: "app-injury-history",
  templateUrl: "./injury-history.component.html",
  styleUrls: ["./injury-history.component.css"],
})
@AutoUnsubscribe
export class InjuryHistoryComponent {
  @Input() formData: any;
  @Output() close = new EventEmitter();

  public injuryHistory: any = [];

  constructor(
    private fb: FormBuilder,
    private _service: InjuryService,
    private spinner: Ng4LoadingSpinnerService,
    private as: AlertService,
    private activeRoute: ActivatedRoute,
    private store: Store<WorkoutsState>,
    private ds: DomSanitizer
  ) {
    console.log("INJURY HISOTRY ==> ", this.formData);
  }

  public todayDateTime = new Date();

  onCancel(event) {
    this.close.emit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.injuryHistory = this.formData;
    console.log("Injury History Data => ", this.injuryHistory);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/workouts/injury-history/injury-history.component.ts